<template>
  <div :class="{
    'color-border-wrapper': true,
    'color-border-wrapper--selected': selected,
    }">
    <div
      :style="color1Style"
      class="color-wrapper"
      @click.prevent="select">
      <div
        class="color-accent"
        :style="color2Style">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'color1',
      'color2',
      'modelId',
      'selected',
    ],
    computed: {
      color1Style() {
        return {
          'background': this.color1
        }
      },
      color2Style() {
        return {
          'border-left-color': this.color2,
          'border-top-color': this.color2,
        }
      }
    },
    methods: {
      select() {
        this.$emit('select', this.modelId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .color-border-wrapper {
    @apply
      hover:border-ctm-primary
      border-transparent
      hover:border-2
      rounded-full
      border-2;

    &.color-border-wrapper--selected {
      @apply
        border-ctm-primary;
    }
  }

  .color-wrapper {
    @apply
      cursor-pointer
      rounded-full
      w-5
      h-5;

    .color-accent {
      @apply
        h-5
        w-5
        rounded-full;
      border-width: 10px;
      border-color: transparent;
    }
  }
</style>